const crypto = require("crypto");
export function cmpClassName(suffix) {
  return `leo-component-${suffix}`;
}
export function getRandom(length = 8, minLength = length) {
  const max = +"9".repeat(length);
  const min = +("1" + "0".repeat(Math.max(0, minLength - 1)));
  return getRandomInt(min === 1 ? 0 : min, max);
}
export function getRandomNum() {
  return crypto.randomBytes(4).readUInt32LE(0) / 4294967295;
}
export function getRandomInt(min, max) {
  const _min = Math.ceil(min);
  const _max = Math.floor(max + 1);
  return Math.floor(getRandomNum() * (_max - _min)) + _min;
}
export function getRandomString(length = 8) {
  const letters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const chars = letters + letters.toUpperCase() + numbers;
  return Array(length).fill(0).map(() => chars.charAt(Math.floor(getRandomNum() * chars.length))).join("");
}
export function getFullName(user) {
  return [user?.first_name.toString(), user?.last_name].filter(Boolean).join(" ");
}
export function getInitials(name, max = 3) {
  if (!name || !name.filter(Boolean).length) {
    return "";
  }
  return name.filter(Boolean).map((n) => n?.slice(0, 1).toUpperCase()).join("").slice(0, max);
}
